/**
 * Setup Required Page
 * Displayed when tenant onboarding is not complete
 */

import { useNavigate } from 'react-router-dom';
import StatusScreen, { StatusInfoBox, StatusPrimaryButton, StatusSecondaryButton } from '../components/layout/StatusScreen';

const CogIcon = (
    <svg width="30" height="30" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
);

export default function SetupRequired() {
    const navigate = useNavigate();

    return (
        <StatusScreen
            iconBg="#eff6ff"
            iconColor="#3b82f6"
            icon={CogIcon}
            title="Setup Required"
            subtitle="Your organization needs to complete the initial setup before you can access the portal. The setup process provisions required resources and configures your tenant."
            actions={
                <>
                    <StatusSecondaryButton onClick={() => { window.location.href = '/'; }}>
                        Return Home
                    </StatusSecondaryButton>
                    <StatusPrimaryButton onClick={() => navigate('/onboarding')}>
                        Go to Setup
                    </StatusPrimaryButton>
                </>
            }
        >
            <StatusInfoBox title="What happens during setup:">
                <ul style={{ margin: 0, paddingLeft: 18, display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <li>SharePoint lists are created</li>
                    <li>Tenant configuration is initialized</li>
                    <li>User access is provisioned</li>
                </ul>
            </StatusInfoBox>
            <StatusInfoBox tone="blue" title="Only site owners can run setup">
                You must be an owner of all licensed SharePoint sites to perform the initial setup.
            </StatusInfoBox>
        </StatusScreen>
    );
}
